import { render, staticRenderFns } from "./AliasIdReportResults.vue?vue&type=template&id=a70948c0&scoped=true&"
import script from "./AliasIdReportResults.vue?vue&type=script&lang=js&"
export * from "./AliasIdReportResults.vue?vue&type=script&lang=js&"
import style0 from "./AliasIdReportResults.vue?vue&type=style&index=0&id=a70948c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70948c0",
  null
  
)

export default component.exports